import React from 'react';

export const numberRenderer = (params: any) => params?.value ? (
  <span className="ag-cell-value">
    {!isNaN(params?.value) ? `${Number(params?.value).toFixed(2)}` : params?.value}
  </span>
) : params?.valueFormatted;
